export class DashboardModel {
  charts: Record<string, DashboardChartData> = {};
  overview: DashboardOverview = new DashboardOverview();
}

export class DashboardDetailRequest {
  dataType: "thread" | "manufacturer" | "part" | "task" = "thread";
  dashboardModel: DashboardModel = new DashboardModel();
  page: number = 1;
  pageSize: number = 25;
}

export class DashboardDetailResponse {
  chartHtml: string = "";
  rows: Array<Record<string, unknown>> = [];
  total: number = 0;
}

export class DashboardChartData {
  data: TextValuePair[] = [];
  hasLicense: boolean = false;
  optionalInfo?: TextValuePair[] = [];
}

class DashboardOverview {
  filters?: DashboardFilters = new DashboardFilters();
  labels: DashboardLabels = new DashboardLabels();
  selectedCharts: string[] = [];
}

export class DashboardFilters {
  [key: string]: number | string | undefined;

  createTimeStart?: number;
  createTimeEnd?: number;
  omApproach?: string;
  assembly?: string;
}

class DashboardLabels {
  total: string = "";
  totalUniqueCases: string = "";
  currency: string = "";
  currencySize: string = "";
}

class TextValuePair {
  text: string = "";
  value: string = "";
}
